import { PACKAGE_ADDONS } from './package'
import { checkAddons } from 'utils/app.utils'

/** คีย์ Addon ข้อความท้าย PDF รายงานค่าตอบแทนทันตแพทย์ (เก็บใน localStorage ไม่ส่ง API) */
export const ADDON_REMUNERATION_CLINIC_FEE_PDF_FOOTER = 'REMUNERATION_CLINIC_FEE_PDF_FOOTER'

/** ใช้สำหรับหน้า Clinic Management > Addon แสดงกลุ่มฟีเจอร์เสริม */
export const ADDON_DISPLAY_CATEGORIES = {
  BRANCH_LAYER: 'CLINIC_MANAGEMENT.ADDON_CATEGORY.BRANCH_LAYER',
  PRICE_RANGE: 'CLINIC_MANAGEMENT.ADDON_CATEGORY.PRICE_RANGE',
  DCC: 'CLINIC_MANAGEMENT.ADDON_CATEGORY.DCC',
  REQUIRE_FINANCE_ACKNOWLEDGE: 'CLINIC_MANAGEMENT.ADDON_CATEGORY.REQUIRE_FINANCE_ACKNOWLEDGE',
  NEW_OLD_PATIENT: 'CLINIC_MANAGEMENT.ADDON_CATEGORY.NEW_OLD_PATIENT',
  ALERT_BEFORE_PAYMENT: 'CLINIC_MANAGEMENT.ADDON_CATEGORY.ALERT_BEFORE_PAYMENT',
  ALERT_TEETH_BEFORE_PAYMENT: 'CLINIC_MANAGEMENT.ADDON_CATEGORY.ALERT_TEETH_BEFORE_PAYMENT',
  TREATMENT_FEE_STATEMENT: 'CLINIC_MANAGEMENT.ADDON_CATEGORY.TREATMENT_FEE_STATEMENT',
  REPORT: 'CLINIC_MANAGEMENT.ADDON_CATEGORY.REPORT'
} as const

export interface AddonDisplayItem {
  key: string
  labelKey: string
  category: keyof typeof ADDON_DISPLAY_CATEGORIES
}

/** การตรวจสอบ addon ในรายการนี้ให้ใช้ checkAddons(key) แทน checkPackage(key) */
const L = 'CLINIC_MANAGEMENT.ADDON_LABEL'
export const ADDON_DISPLAY_LIST: AddonDisplayItem[] = [
  { key: PACKAGE_ADDONS.ADDON_BRANCH_PAGE_LAYER, labelKey: `${L}.BRANCH_PAGE_LAYER`, category: 'BRANCH_LAYER' },
  { key: PACKAGE_ADDONS.ADDON_PRICE_RANGE, labelKey: `${L}.PRICE_RANGE`, category: 'PRICE_RANGE' },
  { key: PACKAGE_ADDONS.ADDON_DCC, labelKey: `${L}.DCC`, category: 'DCC' },
  { key: PACKAGE_ADDONS.ADDON_REQUIRE_FINANCE_ACKNOWLEDGE, labelKey: `${L}.REQUIRE_FINANCE_ACKNOWLEDGE`, category: 'REQUIRE_FINANCE_ACKNOWLEDGE' },
  { key: PACKAGE_ADDONS.ADDON_NEW_OLD_PATIENT, labelKey: `${L}.NEW_OLD_PATIENT`, category: 'NEW_OLD_PATIENT' },
  { key: PACKAGE_ADDONS.ADDON_ALERT_NO_TREATMENT, labelKey: `${L}.ALERT_NO_TREATMENT`, category: 'ALERT_BEFORE_PAYMENT' },
  { key: PACKAGE_ADDONS.ADDON_ALERT_NO_MEDICINE, labelKey: `${L}.ALERT_NO_MEDICINE`, category: 'ALERT_BEFORE_PAYMENT' },
  { key: PACKAGE_ADDONS.ADDON_ALERT_TEETH_BEFORE_PAYMENT, labelKey: `${L}.ALERT_TEETH_BEFORE_PAYMENT`, category: 'ALERT_TEETH_BEFORE_PAYMENT' },
  { key: PACKAGE_ADDONS.ADDON_TREATMENT_FEE_STATEMENT, labelKey: `${L}.TREATMENT_FEE_STATEMENT`, category: 'TREATMENT_FEE_STATEMENT' },
  { key: ADDON_REMUNERATION_CLINIC_FEE_PDF_FOOTER, labelKey: 'CLINIC_MANAGEMENT.ADDON.REMUNERATION_CLINIC_FEE_PDF_FOOTER_TITLE', category: 'REPORT' }
]

/** ใช้ checkAddons แทน checkPackage สำหรับ addon ใน ADDON_DISPLAY_LIST */
export const isAddonInDisplayListEnabled = (key: string): boolean => checkAddons(key)
